/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentMenuProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a content menu provider for the purpose of contributing a content menu
 */
define([], () => {
	class ContentMenuProviderAPI {

		/**
		 * @function ContentMenuProviderAPI#getContentMenuList
		 * @description Returns a list of content menu available contents.
		 * @param {string[]} idList list of content ids
		 * @return {object[]} array containing all available menu
		 * eg. [{
		 * 	id: 'id1',
		 * 	name: 'overlay',
		 * 	label: 'show/hide overlay',
		 * 	action: actionFunction
		 * }]
		 */
		getContentMenuList() { }

	}

	return ContentMenuProviderAPI;
});
